import React, { useState, useEffect } from 'react'
import { Link } from 'gatsby'
import classNames from 'classnames'

import Head from './head'

import './header.scss'

const NAV_ITEMS = [
  { to: '/', label: 'Accueil' },
  {
    to: '/psychologie/',
    label: (
      <>
        Qu'est-ce qu'un psychologue <span>clinicien ?</span>
      </>
    ),
  },
  { to: '/me-connaitre/', label: 'Me connaître' },
  { to: '/pourquoi-consulter/', label: 'Pourquoi consulter ?' },
  { to: '/qui-consulter/', label: 'Qui consulter ?' },
  { to: '/therapie/', label: 'Thérapie' },
  { to: '/tarifs/', label: 'Tarifs' },
  { to: '/galerie/', label: 'Galerie' },
  { to: '/contacts/', label: 'Contacts' },
]

const isMobile = () => typeof window !== 'undefined' && window.innerWidth <= 765

const Header = () => {
  const [menuOpened, setMenuOpened] = useState(false)
  const [menuFixed, setMenuFixed] = useState(false)

  useEffect(() => {
    const handleScroll = () => setMenuFixed(window.pageYOffset >= 300)
    handleScroll()
    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const toggleMenu = () => {
    if (isMobile()) {
      setMenuOpened(opened => !opened)
    }
  }

  const headerClass = classNames('header', {
    'header--opened': menuOpened,
    'header--fixed': menuFixed,
  })

  return (
    <div className="App">
      <Head />
      <nav className={headerClass} aria-label="Navigation principale">
        <div
          className="header__menu-icons"
          onClick={toggleMenu}
          role="button"
          tabIndex={0}
          aria-label={menuOpened ? 'Fermer le menu' : 'Ouvrir le menu'}
          aria-expanded={menuOpened}
          onKeyDown={event => {
            if (event.key === 'Enter' || event.key === ' ') {
              toggleMenu()
            }
          }}
        />
        <ul className="header__menu">
          {NAV_ITEMS.map(({ to, label }) => (
            <li key={to} className="header__menu-item">
              <Link
                activeClassName="header__menu-item--selected"
                to={to}
                onClick={toggleMenu}
              >
                {label}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  )
}

export default Header
